import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import FeaturedMovies from './components/FeaturedMovies';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FaqSection from './components/FaqSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <FeaturedMovies />
        <CategorySection />
        <ArticleSection />
        <NewsletterSection />
        <FaqSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '片多多影视',
            url: 'https://pianduoduo.com',
            description: '片多多影视提供海量高清免费影视资源，不卡顿在线观看，超清画质畅享流畅观影体验。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://pianduoduo.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '片多多影视-片多多高清免费与片多多免费观看',
            description: '片多多影视提供海量高清免费影视资源，片多多免费观看不卡顿，超清画质在线看。全网热门电影电视剧综艺动漫免费看。',
            url: 'https://pianduoduo.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '片多多影视',
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20deep%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20dramatic%20spotlight%2C%20no%20text&width=1200&height=630&seq=og-image-home&orientation=landscape',
            },
          }),
        }}
      />
    </>
  );
}